import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import React from 'react'
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux'
import { createStore, applyMiddleware } from 'redux'
import reduxPromises from 'redux-promise'
import {
    QueryClient,
    QueryClientProvider,
    useQuery,
  } from '@tanstack/react-query'

//import * as serviceWorker from './serviceWorker';
import reportWebVitals from './reportWebVitals';
//import { registerServiceWorker } from "./register-sw";

import App from './components/App'
import reducers from './reducers'

const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false, // default: true
      },
    },
  })

const createStoreWithMiddleware = applyMiddleware(reduxPromises)(createStore);
const root_element = document.getElementById('root')
const root = ReactDOM.createRoot(root_element);
root.render(
    <QueryClientProvider client={queryClient}>
        <Provider store={createStoreWithMiddleware(reducers)}>
            <App />
        </Provider>
    </QueryClientProvider>

);

//registerServiceWorker();
//serviceWorker.unregister();
reportWebVitals();
